import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Mrf/GetList', { params });
  },
  reject(_, idList) {
    return axios.post('Mrf/Reject', idList);
  },
  approve(_, idList) {
    return axios.post('Mrf/Approve', idList);
  },
  getDetailList(_, params) {
    console.log("id", params)
    return axios.get('Mrf/GetDetailList', { params });
  },
};
